/**
* Created by kongwm.kong on 2017/7/25.
*/
<template>
    <div class="fund-table-wrap">
        <table :class="{'fund-table': true, 'table1':isJoined ==1}">
            <thead>
            <tr>
                <th class="th1">操作</th>
                <th  class="th2">公司简称</th>
                <th class="th3">公司全称</th>
                <th  class="th4">成立日期</th>
                <th class="th5">公司网址</th>
                <th  class="th6">企业性质</th>
                <th class="th7">办公地址</th>
                <th  class="th8">更新日期</th>
                <th  class="th9">审核状态</th>
                <th  class="th10">审核意见</th>
            </tr>
            </thead>
            <tbody v-show="!noDataShow">
            <tr v-for="(item , index) in listData">
                <td class="th1" v-if="isJoined==2"><router-link :to="{ name: 'companyDetail' , params: {id: item.id, type: isJoined } }">编辑</router-link></td>
                <td class="th1" v-else><router-link :to="{ name: 'companyDetail' , params: {id: item.fundDcId, type: isJoined } }">编辑</router-link></td>
                <td class="th2">{{item.companyName}}</td>
                <td class="th3">{{item.companyFullName}}</td>
                <td class="th4">{{item.establishDate  | setTime('yyyy-mm-dd')}}</td>
                <td class="th5">{{item.companyUrl}}</td>
                <td class="th6">{{item.companyType | companyNature}}</td>
                <td class="th7">{{item.companyAddress}}</td>
                <td class="th8">{{item.updateTime  | setTime('yyyy-mm-dd')}}</td>
                <td  class="th9">{{item.auditStatus | getAuditStatus }}</td>
                <td  class="th10">{{item.auditComment}}</td>
            </tr>
            </tbody>
        </table>
        <div class="page_wrap" v-show="!noDataShow && showPage">
            <paginate
                    :pageCount="pageCount"
                    :containerClass="'pagination'"
                    :clickHandler="changePage"
                    :pageRange="5"
                    :marginPages="1"
                    :prevText="'&lt;'"
                    :nextText="'&gt;'"
                    :initialPage="initialPage"
                    :pageClass="'page-item'"
            ></paginate>
            <page-jump :showPage="showPageJump" @pageJump="pageJump" :pageNum="getPageJumpNum"></page-jump>
        </div>
        <!--无数据-->
        <no-data :noDataShow="noDataShow"></no-data>
    </div>

</template>
<script>
    import noData from '../../components/common/noData';
    import Paginate from '../../components/middleware/Paginate'
    import pageJump from '../../components/middleware/page-jump';
    export default {
        props: {
            isJoined:{
                required: true
            }
        },
        components:{
            noData,
            Paginate,
            pageJump
        },
        data(){
            return{
                noDataShow: false,
                showPage:false,
                currPage: 1,
                listData: [],
                pageCount: 0,
                showPageJump: false,
                pageJumpNum: 5,
            }
        },
        mounted(){
            this.$store.commit('getLoginInfo',  this.getJoined);
        },
        computed:{
            getPageJumpNum(){
                if( this.pageCount > 5 ){
                    this.showPageJump = true;
                    this.pageJumpNum = Math.ceil(this.currPage / 5) * 5;
                    if(this.pageJumpNum > this.pageCount){
                        this.pageJumpNum = this.pageCount;
                    }else if(this.currPage == this.pageJumpNum &&this.pageJumpNum + 5 <  this.pageCount){
                        this.pageJumpNum = this.pageJumpNum + 5;
                    }
                } else {
                    this.showPageJump = false;
                }
                return  this.pageJumpNum;
            },
            initialPage(){
                return  this.currPage-1;
            }
        },
        methods:{
            getJoined(){
                let flag = 'report';
                if(this.isJoined == 1){ //已加入
                     flag = 'result';
                }
                this.getCompanyList(flag);
            },
            /*请求list*/
            getCompanyList(flag){
                this.$http.request({
                    url: `/company/${flag}/page?pageNo=${this.currPage}&pageSize=10`
                }, response => {
                    let data =  response.data;
                    if(data.code===200){
                        let listData = data.data;
                        if(listData.total && listData.list && listData.list.length){
                            this.listData = listData.list;
                            this.pageCount = Math.ceil(listData.total/ 10);
                            this.noDataShow = false;
                            if(this.pageCount<2){
                                this.showPage = false;
                            } else {
                                this.showPage = true;
                            }
                        } else {
                            this.noDataShow = true;
                        }
                    }else {
                        this.noDataShow = true;
                    }
                }, err => {
                    this.noDataShow = true;
                });
            },
            //改变页码
            changePage(page){
                this.currPage = page;
                this.getJoined();
            },
            /*page-jump*/
            pageJump(page){
                this.changePage(page);
            },

        },
        watch:{
            isJoined(){
                this.noDataShow = false;
                this.currPage = 1;
                this.getJoined();
            },
        }
    }
</script>
<style lang="scss" type="text/scss" scoped>
    .fund-table{
        width:100%;
        padding: 0 20px;
        text-align: center;
        &.table1{
            .th9,.th10{
                display: none;
            }
           /* .th1 {
                width: 52px;
            }
            .th2 {
                width: 112px;
            }
            .th3 {
                width: 130px;
            }
            .th4 {
                width: 90px;
            }
            .th5 {
                width: 102px;
            }
            .th6 {
                width: 90px;
            }
            .th7 {
                width: 120px;
            }
            .th8 {
                width: 70px;
            }*/

        }
        thead{
            background: #F4F8FF;
            font-size:16px;
            color:$c_3c3;
        }
        tbody{
            tr{
                &:nth-child(even){
                    background: #F4F8FF;
                }
                font-size: 14px;
                color:$c_666;
            }
        }
        td, th{
            word-wrap:break-word;
            padding: 20px 5px;
            line-height:1.6;
        }
        .th1{
            width:52px;
            a{
                color:$btn_408;
            }
        }
       /* .th2{
            width:102px;
            padding:0 10px;
        }
        .th3{
            width:120px;
            padding:0 10px;
        }*/
        .th4{
            width:90px;
        }
        .th5{
            width: 140px;
            word-break: break-all
        }
        .th6{
            width:75px;
        }
        .th7{
            width:260px;
        }
        .th8{
            width:90px;
        }
        .th9{
            width:75px;
        }
        .th10{
            width:116px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/company/company_table.vue